<template>
	<div id="organizations" v-loading="loading">
		<div class="row">
			<el-select v-model="OrganizationID" class="topDropdown" placeholder="Select" @change="getOrganization()" default-first-option filterable>
				<el-option v-if="createAccess" key="" label="-- Add New --" value=""></el-option>
				<el-option
					v-for="item in Organizations"
					:label="item.OrganizationName"
					:value="item.OrganizationID"
					:key="item.OrganizationID">
				</el-option>
			</el-select>
		</div>
		<div class="row mt-4">
			<div class="card col-12">
				<el-form ref="organizationsForm" label-position="top" :model="organization" label-width="120px" @submit.native.prevent >
					<div class="row">
						<div class="col-12 col-md-6">
							<el-form-item label="Client Name" prop="OrganizationName"
								:rules="[{ required: true, message: 'Client Name is required', trigger: 'blur'}]"
							>
								<el-input v-model="organization.OrganizationName">
								</el-input>
							</el-form-item>
							<el-form-item label="Parent of Client" prop="ParentOrganizationID">
								<el-select v-model="organization.ParentOrganizationID" style="width: 100%;" placeholder="Select"  default-first-option filterable clearable>
									<el-option
											v-for="item in NonChildOrganizations"
											:label="item.OrganizationName"
											:value="item.OrganizationID"
											:key="item.OrganizationID">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item v-if="!organization.ParentOrganizationID" label="Sub Domain" prop="SubDomain">
								<el-input v-model="organization.SubDomain">
								</el-input>
							</el-form-item>
							<div v-if="!organization.ParentOrganizationID" class="row form-group col-md-12" style="padding-left: 0px;">
								<label class="mb-1 control-label" for="ClientLogo">Client Logo:</label>
								<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
									<div class="fileinput-button " style="text-align:center;">
										<div id="ClientLogo" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="logo" style="position:relative;" :style="ClientLogo">
											<div id="spinner" style="position:absolute;top:24px;left:24px;" v-if="isSaving"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
											<input type="file" id="ClientLogoInput" name="ClientLogo" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
											<div v-if="RemoveLogo" class="deleteLogo" @click.prevent="removelogo"><i class="fas fa-times-circle"></i></div>
										</div>
									</div>
								</form>
							</div>
							<el-form-item v-if="!organization.ParentOrganizationID" label="Phone" prop="ContactPhoneNumber">
								<div class="el-form-item__content">
									<div class="el-input el-input__wrapper">
										<input autocomplete="off" class="el-input__inner" type="tel" v-maska data-maska="(###) ###-####" v-model="organization.Params.ContactPhoneNumber" />
									</div>
								</div>
							</el-form-item>
						</div>
						<div v-if="!organization.ParentOrganizationID" class="col-12 col-md-6">
							<el-form-item label="Address Line 1" prop="AddressLine1">
								<el-input v-model="organization.Params.AddressLine1">
								</el-input>
							</el-form-item>
							<el-form-item label="Address Line 2" prop="AddressLine2">
								<el-input v-model="organization.Params.AddressLine2">
								</el-input>
							</el-form-item>
							<el-form-item label="City" prop="City">
								<el-input v-model="organization.Params.City">
								</el-input>
							</el-form-item>
							<el-form-item label="State" prop="StateOrProvinceCodeID">
								<el-select v-model="organization.Params.StateOrProvinceCodeID" class="oneHundred" placeholder="Select" default-first-option filterable clearable>
									<el-option-group
											v-for="country in StateProvinceCodes"
											:key="country.Country"
											:label="country.Country">
										<el-option
												v-for="state in country.States"
												:key="state.StateProvinceCodeShortName"
												:label="state.StateProvinceCodeName"
												:value="state.StateProvinceCodeShortName">
										</el-option>
									</el-option-group>
								</el-select>
							</el-form-item>
							<el-form-item label="Zip Code" prop="PostalCode" class="postalCode">
								<el-input v-model="organization.Params.PostalCode">
								</el-input>
							</el-form-item>

						</div>
					</div>
					<div class="row mb-4" >
						<div class="col-12">
							<h5>Contacts</h5>
							<el-table
									:data="clientcontacts"
									key="clientcontacts"
									max-height="300"
									border striped
									size="small"
									empty-text="No Contacts"
									style="width: 100%">
								<el-table-column
										prop="ContactName"
										label="Name"
										align="left"
										min-width="150"
								>
									<template #default="scope">
										{{scope.row.FirstName + ' ' + scope.row.LastName}}
									</template>
								</el-table-column>
								<el-table-column
										prop="EmailAddress"
										label="Email Address"
										align="left"
										min-width="200"
								>
								</el-table-column>
							</el-table>
						</div>
					</div>

				</el-form>
			</div>
		</div>
		<div class="row" v-if="(modifyAccess || (createAccess && OrganizationID))" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="saveOrganization" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span> Save Changes</span>
                </button>
                <button v-if="OrganizationID" class="btn btn-icon btn-danger delete" @click="cnfmDeleteOrganization()" style="margin-right: 10px;">
                    <i class="fas fa-trash"></i>  <span>Delete</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fas fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
	import Util from '../assets/js/util.js';
	import { vMaska } from "maska/vue"

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		directives: { maska: vMaska },
		data () {
			return {
				loading : true,
                currentStatus : 0,
				uploadReady : true,
				organization : {Params:{Contacts : []}},
				Organizations : [],
				OrganizationID : null,
				StateProvinceCodes : [],
				clientcontacts : [],
			}
		},
		name: 'Organizations',
		props:["config"],
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
                return Util.createAccess(this.currentUser);
            },
	        modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
			defaultLogo () {
				return require('../images/default_upload.png')
			},
			ClientLogo() {
				let logo = 'backgroundImage: url(' + (this.organization.Params.ClientLogo ? this.organization.Params.ClientLogo : this.defaultLogo) + ')';
				return logo;
			},
			RemoveLogo() {
				if (this.organization.Params.ClientLogo) {
					return true;
				} else {
					return false;
				}
			},
			NonChildOrganizations () {
				let orgs = [];
				for (let i=0; i < this.Organizations.length; i++) {
					if (this.Organizations[i].ParentOrganizationID == 0) {
						orgs.push(this.Organizations[i]);
					}
				}
				return orgs;
			},
		},
		methods: {
			addContact() {
				if (!this.organization.Params.hasOwnProperty('Contacts')) {
					this.organization.Params['Contacts'] = [];
				}
				this.organization.Params.Contacts.unshift(
					{
						ContactName: '',
						ContactEmailAddress: ''
					}
				);
			},
			removeContact(index) {
				this.organization.Params.Contacts.splice(index,1);
			},
			reset(showMessage) {
				// reset form to initial state
				this.currentStatus = STATUS_INITIAL;
				this.getInitialData();
				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: "Organization has been reset",
						type: 'success',
						duration: 1500,
						showClose: false
					});
				}
			},
			getInitialData () {
				var tables = ['StateProvinceCodes'];
				axios.post('/index/tableData', {'tables': tables },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
							this.getAllOrganizations();
						} else {
						}
					}).catch(response => {
				});
			},
			getAllOrganizations() {
				axios.post('/organizations/getall', {},
				)
                .then(response => {
                    if (response.data.result == 'success') {
						this.Organizations = response.data.Organizations;
						if (!this.OrganizationID && this.Organizations.length > 0) {
							if (this.componentIDs.OrganizationID) {
								this.OrganizationID = this.componentIDs.OrganizationID;
							} else {
								this.OrganizationID = this.Organizations[0]['OrganizationID'];
							}
						}
						this.getOrganization () ;
                    } else {;
                    }
                }).catch(response => {
                });
			},
			getOrganization () {
				let self = this;
				this.clientcontacts = [];
				if (this.OrganizationID) {
					axios.post('/organizations/get', {'OrganizationID' : this.OrganizationID},
					)
	                .then(response => {
	                    if (response.data.result == 'success') {
		                    self.$store.dispatch('setID', {'OrganizationID': self.OrganizationID});
							this.organization = response.data.organization;
		                    this.clientcontacts = (response.data.clientcontacts ? response.data.clientcontacts : []);
	                    } else {
	                    }
		                this.loading = false;
	                }).catch(response => {
						this.loading = false;
	                });
                } else {
                    this.organization = {'OrganizationID' : 0, Params: {AddressLine1:"", Contacts:[]}};
					this.loading = false;
                }
			},
			saveOrganization () {
				this.$refs['organizationsForm'].validate((valid) => {
                    if (valid) {
                    	if (!this.isDuplicate ()) {
		                    if (this.currentStatus == STATUS_SAVING) {
								return true;
							}
		                    for (let i = 0; i < this.organization.Params.Contacts.length; i++) {
		                    	if (this.organization.Params.Contacts[i]['ContactName'] == '' || this.organization.Params.Contacts[i]['ContactEmailAddress'] == '') {
				                    this.displayPopup ('For each contact a name and email address must be entered.');
				                    return true;
			                    }
		                    }
							this.currentStatus = STATUS_SAVING;

							axios.post('/organizations/save', {organization : this.organization, clientcontacts : this.clientcontacts}
							)
							.then(response => {
								if (response.data.result == 'success') {
									this.currentStatus = STATUS_INITIAL;
									if (response.data.organization) {
										this.organization = response.data.organization;
									}

									if (response.data.OrganizationID) {
										this.Organizations.push({OrganizationID : response.data.OrganizationID, OrganizationName : this.organization.OrganizationName});
										this.OrganizationID = response.data.OrganizationID;
										this.organization.OrganizationID = response.data.OrganizationID;
									} else {
										for (let i = 0; i < this.Organizations.length; i++) {
											if (this.Organizations[i].OrganizationID == this.organization.OrganizationID) {
												this.Organizations[i].OrganizationName = this.organization.OrganizationName;
												break;
											}
										}
									}

									if (!response.data.message) {
										this.$notify({
											title: 'Success',
											message: 'Client has been saved.',
											type: 'success',
											duration: 1500,
											showClose: false
										});
									} else {
										this.$notify({
											title: 'Warning',
											message: "Client has been saved. " + (response.data.message ? '- ' + response.data.message : ''),
											type: 'warning',
											duration: 3500,
											showClose: false
										});
									}
								} else {
									this.currentStatus = STATUS_FAILED;
									this.displayPopup (response.data.message);
								}
							}).catch(response => {
								this.currentStatus = STATUS_FAILED;
							});
	                    } else {
		                    this.displayPopup ('This Client Name Already Exists.');
	                    }
					}
                });
			},
			isDuplicate () {
				for (let i = 0; i < this.Organizations.length; i++) {
					if (this.Organizations[i].OrganizationID != this.organization.OrganizationID && this.Organizations[i].OrganizationName.toLowerCase() == this.organization.OrganizationName.toLowerCase().trim()) {
						return true;
					}
				}
				return false;
			},
			cnfmDeleteOrganization() {
				this.$confirm('This will permanently delete this Client. Continue?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.deleteOrganization();
				}).catch(() => {
				});
			},
			deleteOrganization () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;
				let self = this;
				axios.post('/organizations/delete', {'OrganizationID': this.OrganizationID}
				)
				.then(response => {
					if (response.data.result == 'success') {
						this.currentStatus = STATUS_INITIAL;

						this.$notify({
							title: 'Success',
							message: "Client has been deleted",
							type: 'success',
							duration: 1500,
							showClose: false
						});
						self.$store.dispatch('setID', {'OrganizationID': ''});
		                this.OrganizationID = '';
		                this.getAllOrganizations();

					} else {
						this.currentStatus = STATUS_FAILED;
						this.displayPopup (response.data.message);
					}
				}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
			emailInvoice(row) {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;
				axios.post('/finance/emailinvoice', {InvoiceID: row.InvoiceID}
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_INITIAL;

							this.$notify({
								title: 'Success',
								message: (response.data.message ? response.data.message : "Invoice has been emailed to the contact on file."),
								type: 'success',
								duration: 0,
								showClose: true
							});

						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
					}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
			uploadLogo(formData) {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				// upload data to the server
				this.currentStatus = STATUS_SAVING;

				axios.post('/settings/uploadlogo', formData,
					{ headers: { 'Content-Type': 'multipart/form-data'} }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_SUCCESS;
							this.organization.Params['ClientLogo'] = response.data.url;
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
						document.getElementById("ClientLogoInput").value = "";
					}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
			filesChange(fieldName, fileList) {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				// handle file changes
				const formData = new FormData();

				if (!fileList.length) return;

				// append the files to FormData
				Array
					.from(Array(fileList.length).keys())
					.map(x => {
						formData.append(fieldName, fileList[x], fileList[x].name);
					});

				// save it
				this.uploadLogo(formData);
			},
			removelogo() {
				this.organization.Params['ClientLogo'] = '';
			},

			displayPopup (message) {
				this.$alert(message, {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
			this.reset(false);
		},
	}
</script>
<style>
	#organizations .color input {
		color: #FFFFFF;
	}
	#organizations .color.White input {
		color: #606266;
	}
	#organizations .White input { background-color: #FFFFFF; }
	#organizations .Red input { background-color: #F44336; }
	#organizations .Pink input { background-color: #E91E63; }
	#organizations .Purple input { background-color: #9C27B0; }
	#organizations .Deep_Purple input { background-color: #673AB7; }
	#organizations .Indigo input { background-color: #3F51B5; }
	#organizations .Blue input { background-color: #2196F3; }
	#organizations .Highlight_Color input { background-color: #1976d2; }
	#organizations .Light_Blue input { background-color:  #03A9F4; }
	#organizations .Cyan input { background-color:  #00BCD4; }
	#organizations .Teal input { background-color:  #009688; }
	#organizations .Green input { background-color:  #4CAF50; }
	#organizations .Light_Green input { background-color:  #8BC34A; }
	#organizations .Lime input { background-color:  #CDDC39; }
	#organizations .Yellow input { background-color:  #FFEB3B; }
	#organizations .Amber input { background-color:  #FFC107; }
	#organizations .Orange input { background-color:  #FF9800; }
	#organizations .Deep_Orange input { background-color:  #FF5722; }
	#organizations .Brown input { background-color:  #795548; }
	#organizations .Blue_Gray input { background-color:  #607D8B; }
	#organizations .Gray input { background-color:  #9E9E9E; }
	#organizations .Black input { background-color:  #000000; }

	#organizations .el-table .is-right .cell {
		padding-right: 20px;
	}

</style>

<style scoped>

    #organizations .form-horizontal {
        width: 100%;
    }
	.card-header {
		margin: -20px -16px 20px -16px;
	}
    .labelDiv label {
        font-size: 14px;
        color: #606266;
        vertical-align: top;
        margin-top: 4px;
    }
	.labelDiv {
		padding: 10px;
		clear:both;
	}
	.labelDiv.odd {
		background-color: #f7f7f7;
	}
	.postalCode .el-input {
		width: 120px;
	}
	#organizations .contactDetails {
		width: 100%;
		text-align: left;
		padding: 5px;
		margin: 1px 0px;
		height: 33px;
		border: 1px solid #DCDFE6;
		-webkit-border-radius: 4px;
		-moz-border-radius: 4px;
		border-radius: 4px;
	}
	#organizations h5 {
		float:left;
		font-weight: 600;
		margin-right: 15px;
		font-size: 16px;
		line-height: 30px;
	}
	.row.header {
		font-weight: 800;
		border-top: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
		height: 50px;
	}
	.odd {
		background-color: #efefef;
	}
	.detailheader {
		border-bottom: 1px solid #e0e0e0;
	}
	.even {
		background-color: #f5f5f5;
	}
	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		left:0;
		top:0;
	}
	#ClientLogo {
		min-width: 50%;
		background: #FFFFFF left center no-repeat;
		background-size: contain;
		cursor: pointer;
	}
	#ClientLogo {
		height: 50px;
	}
	#organizations .logo .success_upload {
		border: 4px solid #28a745;
	}
	#organizations .logo .failed_upload {
		border: 4px solid #dc3545;
	}
	.deleteLogo {
		font-size: 14px;
		cursor:pointer;
		position: absolute;
		top: 0;
		background: #FFF;
		left: 46px;
		color: #666;
		padding: 0px;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		line-height: 9px;
	}
</style>
